export default __webpack_public_path__ + "static/media/favicon.64ded765.ico";